import React, { FunctionComponent, useState } from "react";
import styles from "./Card.module.scss";
import CardProps from "./CardProps.interface";

import { da } from "date-fns/locale";
import { format } from "date-fns";
import Anchor from "components/Anchor/Anchor";
import getImageAspectRatio from "app/media/helpers/getImageAspectRatio";
import ImageViewer from "components/ImageViewer/ImageViewer";
import getRelativeUrl from "helpers/getRelativeUrl";
import Dictionary from "components/Dictionary/Dictionary";
import DynamicHeading from "components/DynamicHeading/DynamicHeading";
import Paragraph from "components/Paragraph/Paragraph";
import getImageCrop from "app/media/helpers/getImageCrop";

const Card: FunctionComponent<CardProps> = (props): JSX.Element => {
    const image = props.image ? props.image : undefined;
    const imageCrop = getImageCrop(image?.umbracoFile.crops, undefined, "Fullscreen (4:3)");
    const imageAspectRatio = getImageAspectRatio(imageCrop, image?.umbracoWidth, image?.umbracoHeight);

    const datePublished = props.datePublished ? new Date(props.datePublished) : new Date();

    return (
        <Anchor className={styles.wrapper} to={getRelativeUrl(props._url)}>
            <div className={styles.inner}>
                {props.image ? (
                    <ImageViewer className={styles.image} src={props.image.umbracoFile.src} focalPoint={props.image.umbracoFile.focalPoint} aspectRatioX={imageAspectRatio.aspectRatioX} aspectRatioY={imageAspectRatio.aspectRatioY} />
                ) : null}

                <div className={styles.content}>
                    <div className={styles.tagline}>
                        {props.tagline ? (
                            <span>{props.tagline}</span>
                        ) : null}

                        {props.tagline && props.datePublished ? (
                            <span className={styles.spacer}></span>
                        ) : null}

                        {props.datePublished ? (
                            <span>{format(datePublished, "MMMM dd, yyyy", { locale: da })}</span>
                        ) : null}
                    </div>

                    {props.heading ? (
                        <DynamicHeading className={styles.heading} headlineSize={"H6"} headlineWeight={"H4"}>{props.heading}</DynamicHeading>
                    ) : null}

                    {props.description ? (
                        <Paragraph className={styles.text} innerHTML={props.description} />
                    ) : null}

                    <span className={styles.link}>
                        <span className={styles.link_adjustment}>
                            <Dictionary name="BLOCKS.BLOG_LIST.READ_MORE" />
                        </span>
                    </span>
                </div>
            </div>
        </Anchor>
    );
};

export default Card;